import { Button } from 'cpool-components/input/Button';
import { BsArrow90DegLeft } from 'react-icons/bs';

type SchufaFieldProps = {
    displayValue?: string;
    onTransfer: () => void;
    disabled?: boolean;
};

const SchufaField: React.FC<SchufaFieldProps> = ({ disabled, displayValue, onTransfer }) => {
    return (
        <div className="flex min-w-0 w-full gap-1.5">
            <Button
                type="button"
                variant="secondary"
                className="h-8 w-8 shrink-0"
                onClick={onTransfer}
                disabled={disabled}
            >
                <BsArrow90DegLeft strokeWidth={1} size={15} />
            </Button>
            <div className="flex h-8 min-w-0 flex-1 items-center truncate rounded-sm bg-[#F5F7FA] px-2 text-sm">
                {displayValue ?? '-'}
            </div>
        </div>
    );
};

export default SchufaField;
